import repository from "../Repository";

export default {
  async register(screenId, infoList, distList) {
    return await repository.post(
      `lodine_tablets_pre_dist_upload`,
      {
        lodine_tablets_residents_info_list: infoList,
        lodine_tablets_pre_dist_ledger_list: distList
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
